export default (function navInit() {
    const nav = {
        searchBtn() {
            $('.js--search_btn').on('click', function (e) {
                $(this).closest('.search').find('form').toggleClass('search__form--show');
                e.preventDefault();
            });
        },
    };
    $(document).ready(() => {
        nav.searchBtn();
    });
}());
